import { Breadcrumbs } from '@rtkwlf/fenrir-react';

import { ContactConciergeLink } from '@packages/components/contact/contact-concierge-link';

import { PageToolbarBack } from './page-toolbar-back/page-toolbar-back';
import { PageToolbarRoot } from './page-toolbar-root/page-toolbar-root';

export const PageToolbar = {
  Back: PageToolbarBack,
  Breadcrumbs,
  RequestHelp: ContactConciergeLink,
  Root: PageToolbarRoot,
};
